import { DownOutlined } from '@ant-design/icons';
import { Grid, Space, Typography } from 'antd';

import UserAvatar from '../../../../components/UserAvatar';
import { useUser } from '../../../../components/UserProvider';

import styles from './styles.module.less';

const UserInfo = () => {
  const { id, email } = useUser();
  const screens = Grid.useBreakpoint();

  return (
    <Space align="center" className={styles.container}>
      <UserAvatar size={18} userId={id} />
      <Space size={4}>
        {!screens.xs && (
          <Typography.Text data-cy="username">{email}</Typography.Text>
        )}
        <DownOutlined className={styles.icon} />
      </Space>
    </Space>
  );
};

UserInfo.displayName = 'UserInfo';

export default UserInfo;
